import { FindConsultsEligibility } from 'domain/usecases/eligibility/find-consults-eligibility'
import { EligibilityRepository } from 'repository/repositories/eligibility/eligibility-repository'

export class RemoteFindConsultsEligibility implements FindConsultsEligibility {
  constructor(private readonly eligibilityRepository: EligibilityRepository) {}
  find(surgical_order_id: number): Promise<FindConsultsEligibility.Model> {
    return this.eligibilityRepository.findConsultsEligibility(surgical_order_id)
  }
}
